import logger, { LogLevelDesc } from 'loglevel'

const level = (import.meta.env.REACT_APP_LOG_LEVEL as LogLevelDesc) || 'info'
logger.setLevel(level)

export default logger
